import { useDispatch, useSelector } from 'react-redux';
import { CircularProgress, IconButton } from '@mui/material';

import {
  addToFavoriteItems,
  removeFromFavoriteList,
  selectIsHasInFavorite,
} from '@app/modules/favorites';
import { Iconify } from './iconify';

type Props = {
  id: string;
  style?: any;
};

const FavUnfavIcon = ({ id, style }: Props) => {
  const dispatch = useDispatch();

  const isFav = useSelector((state: any) => selectIsHasInFavorite(state, id));

  const onPressFav = (event: any) => {
    event.stopPropagation();
    if (isFav) {
      dispatch(removeFromFavoriteList({ uri: id }));
      return;
    }
    dispatch(addToFavoriteItems({ uri: id }));
  };

  const loading = false;

  return (
    <IconButton
      disabled={loading}
      style={style}
      onClick={(event) => onPressFav(event)}
      onMouseDown={(event) => event.stopPropagation()}
    >
      <>
        {!loading ? (
          <Iconify icon={isFav ? 'mdi:heart' : 'mdi:heart-outline'} width={18} sx={{ mt: -1 }} />
        ) : (
          <CircularProgress size={10} />
        )}
      </>
    </IconButton>
  );
};
export { FavUnfavIcon };
